(function () {
  'use strict';

  // Desaturated, ice-blue tinted style to match the Figma showroom map.
  const MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#f3f6fb' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#b2b2b2' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f3f6fb' }] },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#e2e8f2' }],
    },
  ];

  function initMap(el) {
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    const center = { lat: lat, lng: lng };
    const zoom = parseInt(el.dataset.zoom, 10) || 15;

    const map = new google.maps.Map(el, {
      center: center,
      zoom: zoom,
      styles: MAP_STYLE,
      disableDefaultUI: true,
      keyboardShortcuts: false,
      gestureHandling: 'cooperative',
    });

    const marker = el.dataset.marker;

    new google.maps.Marker({
      position: center,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: marker
        ? {
            url: marker,
            scaledSize: new google.maps.Size(48, 48),
            anchor: new google.maps.Point(24, 44),
          }
        : undefined,
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof google === 'undefined' || !google.maps) {
      return;
    }

    document.querySelectorAll('.js-map').forEach(initMap);
  });
})();
